import "./css/features.css";

const Features = () => {
  const currentFeatures = [
    {
      title: "Computer Based Mock Tests (CBT)",
      description: "Practice with various types of computer-based mock tests designed to simulate real exam environments.",
      icon: "fa-solid fa-desktop"
    },
    {
      title: "Previous Years Papers",
      description: "Access a comprehensive collection of previous years' question papers for thorough preparation.",
      icon: "fa-solid fa-file-lines"
    },
    {
      title: "Test Series",
      description: "Specially designed tests for any exam, subject, or topic according to your exact exam pattern.",
      icon: "fa-solid fa-layer-group"
    },
    {
      title: "Practice Sets",
      description: "Auto-generated test papers tailored to your specific exam pattern and preparation requirements.",
      icon: "fa-solid fa-list-check"
    },
    {
      title: "Subject & Topic Tests",
      description: "Practice any specific subject or core topic with our focused and detailed test modules.",
      icon: "fa-solid fa-book-open"
    },
    {
      title: "Time Control",
      description: "Control your test time with timer options. Enable auto-submit or take your desired time.",
      icon: "fa-solid fa-stopwatch"
    },
    {
      title: "Progress Tracking",
      description: "All test scores are saved automatically. Review anytime and identify your weak points easily.",
      icon: "fa-solid fa-chart-line"
    },
    {
      title: "Bilingual Support",
      description: "Exam patterns and question papers available in multiple languages for wider accessibility.",
      icon: "fa-solid fa-language"
    }
  ];

  const upcomingFeatures = [
    {
      title: "Video Lectures & Text Notes",
      description: "Comprehensive study materials available in bilingual format for better understanding.",
      icon: "fa-solid fa-photo-film"
    },
    {
      title: "Advanced Statistics",
      description: "Weekly and monthly performance statistics with interactive charts for detailed analysis.",
      icon: "fa-solid fa-chart-pie"
    },
    {
      title: "AI Support",
      description: "AI-powered assistance to help with complex questions and personalized learning paths.",
      icon: "fa-solid fa-robot"
    }
  ];

  return (
    <div className="featuresPageWrapper">
      
      {/* Header Section */}
      <header className="featuresHeaderContainer">
        <h2 className="featuresTitle">Platform Features</h2>
        <p className="featuresSubtitle">
          A comprehensive study platform designed specifically for students. 
          We're continuously evolving to provide the best learning experience.
        </p>
      </header>

      {/* Current Features Section */}
      <section className="featureSection">
        <div className="sectionHeader">
          <h3><i className="fa-solid fa-circle-check textPrimary"></i> Currently Available</h3>
          <p>Everything you need for effective exam preparation</p>
        </div>
        
        <div className="featuresGrid">
          {currentFeatures.map((feature, index) => (
            <div className="modernFeatureCard" key={index}>
              <div className="featureIconBox">
                <i className={feature.icon}></i>
              </div>
              <h4 className="featureCardTitle">{feature.title}</h4>
              <p className="featureCardDesc">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Upcoming Features Section */}
      <section className="featureSection upcomingSection">
        <div className="sectionHeader">
          <h3><i className="fa-solid fa-hourglass-half textPurple"></i> Coming Soon</h3>
          <p>Exciting new features currently in active development</p>
        </div>
        
        <div className="featuresGrid">
          {upcomingFeatures.map((feature, index) => (
            <div className="modernFeatureCard upcomingCard" key={index}>
              <div className="featureIconBox purpleIcon">
                <i className={feature.icon}></i>
              </div>
              <h4 className="featureCardTitle">{feature.title}</h4>
              <p className="featureCardDesc">{feature.description}</p>
              <span className="upcomingBadge">In Development</span>
            </div>
          ))}
        </div>
      </section>

      {/* Platform Status */}
      <div className="platformStatusBox">
        <div className="statusIcon"><i className="fa-solid fa-code-branch"></i></div>
        <div className="statusContent">
          <h4>Platform Status: Active Development Phase</h4>
          <p>We're actively working to enhance your learning experience with new tools and performance improvements.</p>
        </div>
      </div>
      
    </div>
  );
};

export default Features;